(() => {
  // javascript/script.js
  var queryByData = (data, parent = document) => [
    ...parent.querySelectorAll(`[data-${data}]`)
  ];
  var showDomElement = (element, makeVisible) => element.classList[makeVisible ? "remove" : "add"]("hidden");
  var addClassToElements = (elements, indices, classToAdd) => elements.forEach(
    (element, i) => element.classList[indices.includes(i) ? "add" : "remove"](classToAdd)
  );
  var setElementOrder = (elements, orderIndices) => elements.forEach(
    (element, index) => element.style.order = orderIndices[index]
  );
  var itemWidth = 0;
  var rangeOverflow = (min, max, value) => {
    let range = max - min + 1;
    let result = (value - min) % range + min;
    return result < min ? result + range : result;
  };
  var parseStringValue = (value) => {
    const lowercase = value.toLowerCase();
    if (lowercase === "false") {
      return false;
    }
    if (lowercase === "true") {
      return true;
    }
    const numberValue = Number(value);
    if (Number.isNaN(numberValue) === false) {
      return numberValue;
    }
    return value;
  };
  var elementsToIndices = (elements, activeIndices, invert = false) => elements.map((element, index) => index).filter((index) => activeIndices.includes(index) !== invert);
  var rangeFrom = (from, to) => Array(1 + (to - from)).fill(0).map((element, index) => index + from);

  function SimpleObservable(value = null) {
    let subscribers = [];
    const notify = (previousValue) => subscribers.forEach((sub) => sub(previousValue));
    const next = (val) => {
      const previousValue = value;
      value = val;
      notify(previousValue);
    };

    const subscribe = (sub) => {
      if (subscribers.includes(sub)) {
        return false;
      }

      subscribers.push(sub);

      return () => unsubscribe(sub);
    };

    const unsubscribe = (sub) => {
      if (subscribers.includes(sub) == false) {
        return false;
      }

      subscribers = subscribers.filter((item) => item !== sub);

      return true;
    };

    return {
      getValue: () => value,
      next,
      subscribe
    };
  }

  function Slider(handle, slides = [], activeSlideIndex = 0, slidesVisible = 1) {
    const _activeSlideIndex = new SimpleObservable(activeSlideIndex);
    const _handle = handle;

    return {
      handle: _handle,
      slides,
      activeSlideIndex: _activeSlideIndex,
      slidesVisible,
      groups: {}
    };
  }

  function SlidingTabs(handle, tabs = [], activeTabIndex = 0) {
    const _activeTabIndex = new SimpleObservable(activeTabIndex);
    const _handle = handle;

    return {
      handle: _handle,
      tabs,
      activeTabIndex: _activeTabIndex,
      markerElement: null
    };
  }

  window.addEventListener("load", () => {
    let customVariables = {};

    queryByData("toggle-on-click").forEach((item) => {
      let variableName = item.dataset.toggleOnClick;

      if (customVariables.hasOwnProperty(variableName) === false) {
        customVariables[variableName] = new SimpleObservable(false);
      }

      item.addEventListener(
        "click",
        () => customVariables[variableName].next(
          !customVariables[variableName].getValue()
        )
      );
    });

    queryByData("switch-on-click").forEach((item) => {
      let [variableName, variableValue] = item.dataset.switchOnClick.split(":");
      
      if (customVariables.hasOwnProperty(variableName) === false) {
        customVariables[variableName] = new SimpleObservable();
      }

      variableValue = parseStringValue(variableValue);

      if (customVariables[variableName].getValue() === null) {
        customVariables[variableName].next(variableValue);
      }
      
      item.addEventListener(
        "click",
        () => customVariables[variableName].next(variableValue)
      );
    });

    queryByData("show-if").forEach((item) => {
      let [variableName, variableValue] = item.dataset.showIf.split(":");

      if (customVariables.hasOwnProperty(variableName) === false) {
        customVariables[variableName] = new SimpleObservable();
      }

      variableValue = parseStringValue(variableValue);

      if (customVariables[variableName].getValue() === null) {
        customVariables[variableName].next(variableValue);
      }

      const unsubscribe = customVariables[variableName].subscribe(
        (previousValue) => showDomElement(
          item,
          customVariables[variableName].getValue() === variableValue
        )
      );

      if (unsubscribe) {
        showDomElement(
          item,
          customVariables[variableName].getValue() === variableValue
        );
      }
    });

    let sliders = {};

    queryByData("slide").forEach((item) => {
      const handle = item.dataset.slide;
      sliders[handle] = sliders[handle] || new Slider(handle);
      sliders[handle].slides.push(item);
    });

    queryByData("slide-slides-visible").forEach((item) => {
      let [handle, slidesVisible] = item.dataset.slideSlidesVisible.split(":");

      if (slidesVisible === "" || slidesVisible === void 0) {
        slidesVisible = 1;
      } else {
        slidesVisible = Number(slidesVisible);
      }

      sliders[handle] = sliders[handle] || new Slider(handle);
      sliders[handle].slidesVisible = slidesVisible;
    });

    queryByData("slide-previous").forEach((item) => {
      const handle = item.dataset.slidePrevious;
      sliders[handle] = sliders[handle] || new Slider(handle);

      item.addEventListener("click", () => {
        const nextSlideIndex = rangeOverflow(
          0,
          sliders[handle].slides.length - 1,
          sliders[handle].activeSlideIndex.getValue() - 1
        );

        sliders[handle].activeSlideIndex.next(nextSlideIndex);
      });
    });

    queryByData("slide-next").forEach((item) => {
      const handle = item.dataset.slideNext;

      sliders[handle] = sliders[handle] || new Slider(handle);

      item.addEventListener("click", () => {
        const nextSlideIndex = rangeOverflow(
          0,
          sliders[handle].slides.length - 1,
          sliders[handle].activeSlideIndex.getValue() + 1
        );

        sliders[handle].activeSlideIndex.next(nextSlideIndex);
      });
    });

    queryByData("slide-content").forEach((item) => {
      const handle = item.dataset.slideContent;
      let group = item.dataset.slideContentGroup;

      sliders[handle] = sliders[handle] || new Slider(handle);
      sliders[handle].groups[group] = sliders[handle].groups[group] || [];
      sliders[handle].groups[group].push(item);
    });

    Object.keys(sliders).forEach((handle) => {
      const slider = sliders[handle];

      slider.activeSlideIndex.subscribe(
        (previousValue) => changeSlide(slider, previousValue)
      );

      changeSlide(slider);

      if (slider.groups["content"]) {
        slider.activeSlideIndex.subscribe(
          (previousValue) => changeSlideContent(slider, previousValue)
        );

        changeSlideContent(slider);
      }

      if (slider.groups["indicators"]) {
        const container = slider.groups["indicators"][0].parentElement;

        for (let i = 1; i < slider.slides.length; i++) {
          const indicator = slider.groups["indicators"][0].cloneNode();
          container.append(indicator);
          slider.groups["indicators"].push(indicator);
        }

        slider.activeSlideIndex.subscribe(
          (previousValue) => changeSlideIndicators(slider, previousValue)
        );

        changeSlideIndicators(slider);
      }

      if (slider.groups["progress"]) {
        slider.activeSlideIndex.subscribe(
          (previousValue) => updateSliderProgressBar(slider, previousValue)
        );

        updateSliderProgressBar(slider);
      }
    });

    let slidingTabs = {};
    queryByData("sliding-tab").forEach((item) => {
      const handle = item.dataset.slidingTab;
      slidingTabs[handle] = slidingTabs[handle] || new SlidingTabs(handle);
      slidingTabs[handle].tabs.push(item);
    });

    Object.keys(slidingTabs).forEach((handle) => {
      const markerElement = document.querySelector(
        `[data-sliding-tab-marker="${handle}"]`,
      );
      const slidingTabsGroup = slidingTabs[handle];
      slidingTabsGroup.markerElement = markerElement;
      slidingTabsGroup.tabs.forEach(
        (tab, index) => tab.addEventListener(
          "click",
          () => slidingTabsGroup.activeTabIndex.next(index)
        )
      );
      slidingTabsGroup.activeTabIndex.subscribe(
        (previousValue) => changeSlidingTab(slidingTabsGroup, previousValue)
      );
      changeSlidingTab(slidingTabsGroup);
    });
  });

  var changeSlide = (slider, previousValue) => {
    const activeSlideIndex = slider.activeSlideIndex.getValue();
    const activeIndices = rangeFrom(
      activeSlideIndex,
      activeSlideIndex + slider.slidesVisible - 1
    ).map((index) => rangeOverflow(0, slider.slides.length - 1, index));
    const hiddenIndices = elementsToIndices(slider.slides, activeIndices, true);
    
    addClassToElements(slider.slides, hiddenIndices, "hidden");
    setElementOrder(
      slider.slides.map((slide) => slide.children[0]),
      rangeFrom(
        activeSlideIndex,
        activeSlideIndex + slider.slides.length - 1
      ).reverse()
    );
    
    let orderIndices = slider.slides.map(
      (slide, index) => rangeOverflow(0, slider.slides.length - 1, index - activeSlideIndex)
    );
    
    setElementOrder(
      slider.slides.map((slide) => slide.children[0]),
      orderIndices
    );
  };

  var changeSlideContent = (slider, previousValue) => {
    const hiddenIndices = elementsToIndices(
      slider.slides,
      [slider.activeSlideIndex.getValue()],
      true
    );
    
    addClassToElements(slider.groups["content"], hiddenIndices, "hidden");
  };

  var changeSlideIndicators = (slider, previousValue) => {
    const activeIndices = elementsToIndices(
      slider.slides,
      [slider.activeSlideIndex.getValue()],
      false
    );
    
    const inactiveIndices = elementsToIndices(
      slider.slides,
      [slider.activeSlideIndex.getValue()],
      true
    );
    
    addClassToElements(
      slider.groups["indicators"],
      activeIndices,
      "bg-lyle-green-light"
    );
    
    addClassToElements(
      slider.groups["indicators"],
      inactiveIndices,
      "bg-slate-400"
    );
  };

  var updateSliderProgressBar = (slider, previousValue) => {
    const progressElement = slider.groups["progress"][0];
    const progressPercentage = 100 * ((slider.activeSlideIndex.getValue() + 1) / slider.slides.length);
    
    progressElement.style.width = progressPercentage + "%";
  };

  var changeSlidingTab = (slidingTabs, previousValue) => {
    let activeIndex = slidingTabs.activeTabIndex.getValue();
    let tempSlidingTabs = {};
    let handle = '';
    let excludeCount = 0;
    
    slidingTabs.tabs.forEach((item) => {
      if (!item.classList.contains('ignore-me')) {
        handle = item.dataset.slidingTab;
        tempSlidingTabs[handle] = tempSlidingTabs[handle] || new SlidingTabs(handle);
        tempSlidingTabs[handle].tabs.push(item);
      } else {
        excludeCount++;
      }
    });
    
    tempSlidingTabs = tempSlidingTabs[handle];
    tempSlidingTabs.markerElement = slidingTabs.markerElement;
    
    if (activeIndex >= excludeCount) {
      activeIndex = activeIndex - excludeCount;
    }
    
    const activeIndices = elementsToIndices(
      tempSlidingTabs.tabs,
      [activeIndex],
      false
    );
    
    const inactiveIndices = elementsToIndices(
      tempSlidingTabs.tabs,
      [activeIndex],
      true
    );
    
    addClassToElements(tempSlidingTabs.tabs, activeIndices, "text-white");
    addClassToElements(tempSlidingTabs.tabs, inactiveIndices, "text-black");
    tempSlidingTabs.markerElement.style.translate = activeIndex * 100 + "%";
  };

  var Drag = class {
    isDragging = false;
    currentPosition = 0;
    startingPosition = 0;
    deltaPosition = 0;
    sinceLastUpdate = 0;
    constructor() { }
    // called when the drag first starts
    start(position) {
      this.isDragging = true;
      this.startingPosition = position;
      this.currentPosition = position;
      this.deltaPosition = 0;
      this.sinceLastUpdate = 0;
    }

    move(position) {
      this.currentPosition = position;
      this.sinceLastUpdate = this.deltaPosition;
      this.deltaPosition = this.currentPosition - this.startingPosition;
      this.sinceLastUpdate = this.deltaPosition.clone - this.sinceLastUpdate;
    }

    end() {
      this.isDragging = false;
      this.startingPosition = 0;
      this.deltaPosition = 0;
      this.sinceLastUpdate = 0;
    }
  };

  function Carousel(carouselWrapper) {
    if (carouselWrapper instanceof HTMLElement === false) {
      return;
    }
    const carouselId = carouselWrapper.dataset.carouselId;
    const carousel = carouselWrapper.querySelector(
      '.carousel[data-carousel-id="' + carouselId + '"]'
    );
    const previousButton = document.querySelector(
      '.carousel-button-previous[data-carousel-id="' + carouselId + '"]'
    );
    const nextButton = document.querySelector(
      '.carousel-button-next[data-carousel-id="' + carouselId + '"]'
    );
    const progressBar = document.querySelector(
      '.carousel-progress-bar[data-carousel-id="' + carouselId + '"]'
    );
    const gap = 16;

    if (itemWidth < 1) {
      itemWidth = carousel.querySelector(".carousel-slide").clientWidth + gap;
    }

    const drag = new Drag();
    let carouselStart = 0;
    const progressPercent = SimpleObservable(0);
    let allowClicks = true;

    function getCursorPosition(event) {
      if (event.touches) {
        return event.touches[0].pageX;
      }

      return event.pageX;
    }

    function dragStart(event) {
      carouselStart = carousel.scrollLeft;
      drag.start(getCursorPosition(event));
      carousel.style.scrollBehavior = "auto";
      carousel.style.scrollSnapType = "none";

      if (progressBar) {
        progressBar.style.transition = "";
      }
    }

    function dragEnd(event) {
      if (drag.isDragging === false) {
        return;
      }

      if (!event.touches) {
        event.preventDefault();
      }

      carousel.scrollLeft = carouselStart - drag.deltaPosition;
      drag.end();
      carouselStart = 0;
      carousel.style.scrollBehavior = "smooth";
      carousel.style.scrollSnapType = "x proximity";

      if (progressBar) {
        progressBar.style.transition = "width .2s";
      }

      updateProgressPercent();
      setTimeout(() => allowClicks = true, 50);
    }

    function dragMove(event) {
      if (drag.isDragging === false) {
        return;
      }
      if (!event.touches) {
        event.preventDefault();
      }

      allowClicks = false;
      drag.move(getCursorPosition(event));
      carousel.scrollLeft = carouselStart - drag.deltaPosition;
    
      updateProgressPercent();
    }

    function scrollToPrevious(event) {
      carousel.scrollLeft -= itemWidth;
    }

    function scrollToNext(event) {
      carousel.scrollLeft += itemWidth;
    }

    function updateProgressPercent() {
      progressPercent.next(
        (carousel.scrollLeft + carousel.clientWidth) / carousel.scrollWidth * 100
      );
    }

    function updateProgressBar(previousValue) {
      progressBar.style.width = progressPercent.getValue() + "%";
    }

    function x() {
      updateProgressPercent();
      requestAnimationFrame(x);
    }

    x();
    carousel.addEventListener("dragstart", (e) => e.preventDefault());
    carousel.addEventListener("drag", (e) => e.preventDefault());
    carousel.addEventListener("dragend", (e) => e.preventDefault());
    carousel.addEventListener("mousedown", dragStart);
    carousel.addEventListener("touchstart", dragStart);
    window.addEventListener("mousemove", dragMove);
    window.addEventListener("touchmove", dragMove);
    window.addEventListener("mouseup", dragEnd);
    window.addEventListener("touchend", dragEnd);
    carousel.addEventListener("click", (event) => {
      if (!allowClicks)
        event.preventDefault();
    });

    if (previousButton) {
      previousButton.addEventListener("click", scrollToPrevious);
    }

    if (nextButton) {
      nextButton.addEventListener("click", scrollToNext);
    }

    if (progressBar) {
      progressPercent.subscribe(updateProgressBar);
      updateProgressPercent();
      progressBar.style.transition = "width .2s";
    }
  }

  window.addEventListener("load", function () {
    document.querySelectorAll(".carousel-wrapper").forEach((carouselWrapper) => Carousel(carouselWrapper));
    // If review submitted set review tab as active
    setActiveTab('recipesPageSelectedTab:Reviews', '#comment-');
  });

  document.addEventListener("DOMContentLoaded", () => {
    let path = window.location.pathname.split("/").filter((x) => x !== "");
    let isRecipePage = path.includes("recipe") && path.pop() !== "recipe";
    if (!isRecipePage) {
      return;
    }
    let UNIT_DATA = {
      "GRAM": {
        short: "g",
        long: "gram",
        system: "metric"
      },
      "CUP": {
        short: "cup",
        long: "cup",
        system: "imperial"
      },
      "TABLESPOON": {
        short: "tbsp",
        long: "tablespoon",
        system: "imperial"
      },
      "MILLILITER": {
        short: "ml",
        long: "milliliter",
        system: "metric"
      },
      "OUNCE": {
        short: "oz",
        long: "ounce",
        system: "imperial"
      },
      "TEASPOON": {
        short: "tsp",
        long: "teaspoon",
        system: "imperial"
      },
      "FLUID_OUNCE": {
        short: "floz",
        long: "fluid ounce",
        system: "imperial"
      },
      "PIECE": {
        short: "pcs",
        long: "piece",
        system: ""
      },
      "": {
        short: "",
        long: "",
        system: ""
      }
    };
    let UNIT_CONVERSIONS = {
      "GRAM": {
        to: "OUNCE",
        conversion_factor: 0.0352739619
      },
      "CUP": {
        to: "MILLILITER",
        conversion_factor: 236.588
      },
      "TABLESPOON": {
        to: "MILLILITER",
        conversion_factor: 14.7868
      },
      "OUNCE": {
        to: "GRAM",
        conversion_factor: 28.3495231
      },
      "TEASPOON": {
        to: "MILLILITER",
        conversion_factor: 4.92892
      },
      "FLUID_OUNCE": {
        to: "MILLILITER",
        conversion_factor: 29.5735296
      },
      "PIECE": {
        to: "PIECE",
        conversion_factor: 1
      },
      "MILLILITER": {
        to: "FLUID_OUNCE",
        conversion_factor: 0.033814
      },
      "": {
        to: "",
        conversion_factor: 1
      }
    };

    const convertAmount = (fromUnit, amount) => UNIT_CONVERSIONS[fromUnit].conversion_factor * amount;
    const convertUnit = (fromUnit) => UNIT_CONVERSIONS[fromUnit].to;
    let currentSystem = "metric";
    const metricButton = document.getElementById("metricUnits");
    const imperialButton = document.getElementById("imperialUnits");
    const ingredientElements = [...document.querySelectorAll("[data-convert-amount]")];
    const lessServingsButton = document.getElementById("lessServings");
    const moreServingsButton = document.getElementById("moreServings");
    const servingCountElement = document.getElementById("servingCount");
    let servings = Number(servingCountElement.innerText);
    const minServings = servings;
    const updateServings = (value) => {
      servings = Math.max(minServings, value);
      servingCountElement.innerText = servings;

      if (currentSystem === "metric") {
        onMetricPress();
      }

      if (currentSystem === "imperial") {
        onImperialPress();
      }
    };

    const onMetricPress = () => {
      convertTo("metric");
      metricButton.classList.add("active");
      imperialButton.classList.remove("active");
    };

    const onImperialPress = () => {
      convertTo("imperial");
      imperialButton.classList.add("active");
      metricButton.classList.remove("active");
    };

    const convertTo = (system) => {
      currentSystem = system;

      for (let element of ingredientElements) {
        let data = element.dataset.convertAmount;

        if (data != "pinch") {
          let { amounts, unit } = parseIngredientAmount(data);

          if (UNIT_DATA[unit] !== undefined) {
            if (UNIT_DATA[unit].system !== system) {
              amounts = convertAmount(unit, amounts);
              unit = UNIT_DATA[convertUnit(unit)].short;
            } else {
              unit = UNIT_DATA[unit].short;
            }
          }

          let number = Number((amounts * servings).toFixed(2));
          number = getFractionSymbol(number);
          element.textContent = number + " " + unit;
        }
      }
    };

    const parseIngredientAmount = (data) => {
      data = data.toLowerCase().replace(" ", "").trim();
      let amount_regex = new RegExp(/([\d\-\.\,\/ ]*\d)|(\d)/, "gi");
      let amount = data.match(amount_regex);

      if (amount == null) {
        // check for fraction symbols eg. ½
        let fractionSymbols = ["½", "⅓", "⅔", "¼", "¾"];

        for (let fractionSymbol of fractionSymbols) {
          if (data.includes(fractionSymbol)) {
            let fractionValue = getFractionValue(fractionSymbol);
            amount = [fractionValue];
            data = data.replace(fractionSymbol, fractionValue);
          }
        }
      }

      if (!amount || amount.length == 0) {
        return { amounts: [], unit: " " };
      }

      let unit = data.substring(String(amount).length);
      for (let UNIT in UNIT_DATA) {
        if (unit !== UNIT_DATA[UNIT].short) {
          continue;
        }
        unit = UNIT;
        break;
      }

      return {
        amounts: amount,
        unit
      };
    };

    const getFractionValue = (fractionSymbol) => {
      let value = 0;

      switch (fractionSymbol) {
        case '½': value = '0.5'; break;
        case '⅓': value = '0.33'; break;
        case '⅔': value = '0.66'; break;
        case '¼': value = '0.25'; break;
        case '¾': value = '0.75'; break;
      }
      return value;
    };

    const getFractionSymbol = (fractionValue) => {
      let symbol = fractionValue;

      switch (fractionValue) {
        case 0.5: symbol = '½'; break;
        case '0.33': symbol = '⅓'; break;
        case '0.67': symbol = '⅔'; break;
        case '0.25': symbol = '¼'; break;
        case '0.75': symbol = '¾'; break;
      }
      return symbol;
    };

    metricButton.addEventListener("click", onMetricPress);
    imperialButton.addEventListener("click", onImperialPress);
    lessServingsButton.addEventListener("click", () => updateServings(servings - 1));
    moreServingsButton.addEventListener("click", () => updateServings(servings + 1));
    updateServings(servings);
  });

  // MAILCHIMP integration
  // get all the newsletter forms on the page
  const formBlocks = document.querySelectorAll('.newsletter-signup-form');

  // handle each form individually
  formBlocks.forEach(formBlock => {
    const form = formBlock.querySelector('form');
    const emailInput = formBlock.querySelector('input[type="email"]');
    const feedbackDiv = formBlock.querySelector('.signup-feedback');

    form.addEventListener('submit', function(event) {
      event.preventDefault();
      
      const emailValue = emailInput.value;
      
      if (emailValue.trim() === '') {
        feedbackDiv.textContent = 'Please enter your email address.';
      
        return;
      }
      
      // send to the backend
      const url = php.ajax_url;
      var data = new FormData(this);
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);

      xhr.onreadystatechange = function() {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
                var response = JSON.parse(xhr.responseText);

                feedbackDiv.textContent = response.message;

                form.reset();
            } else {

              feedbackDiv.textContent = '<p>Something went wrong, sorry!</p>';
            }
          }
      };

      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.send(data);

    });
  });
})();

const setActiveTab = (element, hash) => {
  if (window.location.href.indexOf(hash) > -1) {
    const tabs = document.querySelectorAll('[data-switch-on-click]');

    tabs.forEach((tab) => {
      if (tab.dataset.switchOnClick === element) {
        tab.click();
        tab.scrollIntoView({behavior: 'smooth'});
      }
    })
  }
}